import { FavouriteLocationsTable } from "@/components/organisms/MyFavourites/FavouriteLocationsTable";

export const FavouriteLocations = () => {
  return <FavouriteLocationsTable />;
};
